import { logGreyError } from "owa-analytics";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";
import { executeSignoutPromises } from "./executeSignoutPromises";

export function onSignoutClick(): void {
    executeSignoutPromises().catch(e => {
        logGreyError("PlacesSignoutCleanupError", getModuleContextMailboxInfo(), e);
    });
}
